<template>
  <div v-if="section.config.carousel">
    <div class="row q-gutter-md ">
      <model-form-input
        field="config.carousel.title"
        value-type="String"
        class="col"
        label="Title"
      />
      <model-form-toggle
        field="config.carousel.showTitle"
        value-type="Boolean"
        class="col-2 q-my-auto q-mr-md"
        label="Show Title"
        size="lg"
      />
    </div>
    <div class="row q-col-gutter-md q-mb-lg">
      <model-form-select
        field="config.carousel.type"
        value-type="String"
        class="col-3"
        :options="$mh.asOptions(CAROUSEL_TYPES.ALL)"
        map-options
        emit-value
        label="Carousel Type"
      />
      <model-form-checkbox
        v-if="section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL"
        field="config.carousel.keepRatio"
        value-type="Boolean"
        class="col"
        label="Keep Image Aspect Ratio"
        size="lg"
      />

      <model-form-checkbox
        v-if="section.config.carousel.type === CAROUSEL_TYPES.SLIDER"
        field="config.carousel.cleanImage"
        value-type="Boolean"
        class="col"
        label="Clean Image"
        bottom-slots
      />
      <model-form-toggle
        field="config.carousel.controlsVisible"
        value-type="Boolean"
        class="col q-mr-md"
        label="Controls Visible"
        size="lg"
      />
      <model-form-toggle
        field="config.carousel.paginationVisible"
        value-type="Boolean"
        class="col q-mr-md"
        label="Pagination Visible"
        size="lg"
      />

      <div
        class="row col-auto"
      >
        <model-form-toggle
          field="config.autoplay"
          value-type="Boolean"
          class="col-6 q-my-auto q-mr-md"
          label="Auto play"
          bottom-slots
          size="lg"
        />

        <model-form-input
          v-if="section.config.autoplay"
          field="config.delayInSeconds"
          value-type="Number"
          class="col"
          label="Delay (seconds)"
          type="number"
          min="0"
          max="60"
          step="0.5"
          @update:model-value="changeCount++"
        />
      </div>
    </div>
    <button-style-editor
      v-if="section.config.carousel.controlsVisible"
      class="row"
      button-type-label="Controls Button Type"
      color-label="Controls Button Color"
      border-radius-label="Controls Border Radius"
      :button-type="section.config.carousel.controlsType"
      :color-name="section.config.carousel.controlsColor"
      :custom-color-hex="section.config.carousel.controlsColorHex"
      :button-border-radius="section.config.carousel.controlsBorderRadius"
      @update:model-value="setControlsStyle"
    />
    <div class="row q-mb-sm q-mt-lg">
      <div class="text-bold">
        {{ $_.startCase(section.config.carousel.type) }}s Styling
      </div>
    </div>

    <div class="row q-col-gutter-md q-mb-xl">
      <template v-if="(section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL && !section.config.carousel.keepRatio) || (section.config.carousel.type === CAROUSEL_TYPES.SLIDER && !section.config.carousel.cleanImage)">
        <model-form-select
          field="config.carousel.imageTransformationType"
          value-type="String"
          class="col-3"
          :options="$mh.asOptions(IMAGE_TRANSFORM_OPTIONS.ALL)"
          map-options
          emit-value
          label="Image Fit"
        />
        <model-form-select
          field="config.carousel.imagePositionType"
          value-type="String"
          class="col-3"
          :options="$mh.asOptions(IMAGE_POSITION_OPTIONS.ALL)"
          map-options
          emit-value
          label="Image Position"
        />
      </template>
      <template v-if="section.config.carousel.type === CAROUSEL_TYPES.SLIDER">
        <div class="col-6 col-sm-3">
          <q-item-label>Slider Padding</q-item-label>
          <q-slider
            v-model="section.config.carousel.spacing"
            label
            label-always
            switch-label-side
            type="number"
            :min="0"
            :max="20"
            :step="1"
          />
        </div>
        <div class="col-6 col-sm-3">
          <q-item-label>Slider Border Radius</q-item-label>
          <q-slider
            v-model="section.config.carousel.posterBorderRadius"
            label
            label-always
            switch-label-side
            type="number"
            :min="0"
            :max="20"
            :step="1"
          />
        </div>
        <div
          class="col-6 col-sm-3"
        >
          <q-item-label>Shadow</q-item-label>
          <q-slider
            v-model="section.config.shadow"
            label
            label-always
            switch-label-side
            type="number"
            :min="0"
            :max="10"
            :step="1"
          />
        </div>
        <div
          class="col-6 col-sm-3"
        >
          <q-item-label>Maximum Slides Per View</q-item-label>
          <q-slider
            v-model="section.config.carousel.slidesPerView"
            label
            label-always
            switch-label-side
            type="number"
            :min="1"
            :max="10"
            :step="1"
            @change="changeCount++"
          />
        </div>
        <div
          class="col-6 col-sm-3"
        >
          <q-item-label>Slider Height</q-item-label>
          <q-slider
            v-model="section.config.carousel.sliderHeight"
            label
            label-always
            switch-label-side
            type="number"
            :min="100"
            :max="1000"
            :step="20"
          />
        </div>
        <div
          class="col-6 col-sm-3"
        >
          <model-form-checkbox
            field="config.carousel.centred"
            value-type="Boolean"
            class="col-3"
            label="Centred"
          />
        </div>
      </template>
      <template
        v-if="section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL"
      >
        <div
          v-if="!section.config.carousel.keepRatio"
          class="col-6 col-sm-3"
        >
          <q-item-label>Banner Height</q-item-label>
          <q-slider
            v-model="section.config.carousel.carouselHeight"
            label
            label-always
            switch-label-side
            type="number"
            :min="100"
            :max="1000"
            :step="20"
          />
        </div>
        <div
          v-if="!section.config.carousel.keepRatio"
          class="col-6 col-sm-3"
        >
          <model-form-checkbox
            field="config.carousel.hasMobileCarouselHeight"
            value-type="Boolean"
            class="col-3"
            label="Different Banner Height on Mobile"
            @update:model-value="changeCount++"
          />
        </div>
        <div
          v-if="!section.config.carousel.keepRatio && section.config.carousel.hasMobileCarouselHeight"
          class="col-6 col-sm-3"
        >
          <q-item-label>Mobile Banner Height </q-item-label>
          <q-slider
            v-model="section.config.carousel.mobileCarouselHeight"
            label
            label-always
            switch-label-side
            type="number"
            :min="100"
            :max="1000"
            :step="20"
          />
        </div>

        <model-form-select
          field="config.carousel.textPositionType"
          value-type="String"
          class="col-3"
          :options="$mh.asOptions(TEXT_POSITION_TYPES.ALL)"
          map-options
          emit-value
          label="Text Position"
        />
        <model-form-select
          field="config.carousel.textAlignType"
          value-type="String"
          class="col-3"
          :options="$mh.asOptions(TEXT_ALIGN_OPTIONS.ALL)"
          map-options
          emit-value
          label="Text Align"
        />
      </template>
      <button-style-editor
        class="row col-12"
        :button-type="section.config.carousel.buttonType"
        :color-name="section.config.carousel.buttonColor"
        :custom-color-hex="section.config.carousel.buttonColorHex"
        :button-border-radius="section.config.carousel.buttonBorderRadius"
        @update:model-value="setButtonStyle"
      />
    </div>

    <div
      v-if="section.config.carousel.type"
      class="row q-gutter-md q-mb-md"
    >
      <q-table
        v-model:pagination="pagination"
        class="col"
        :columns="[
          { label: 'Image', name: 'image', field: carouselItem => carouselItemImageUrl(carouselItem[localizeKey('image')] || carouselItem.image), align: 'left' , component: 'img' },
          { name: 'title', align: 'left', label: 'Title', field: 'title' },
          { name: 'description', align: 'left', label: 'Description', field: 'description' },
          { name: 'hasLink', align: 'left', label: 'Link Active', field: 'hasLink', component: 'checkbox' },
          { name: 'linkUrl', align: 'left', label: 'Link Url', field: 'linkUrl' },
          { name: 'buttonText', align: 'left', label: 'Button Text', field: 'buttonText' },
          { name: section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL ? 'showVideo' : undefined, align: 'left', label: section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL ? 'Has Video' : undefined, field: section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL ? 'showVideo' : undefined, component: section.config.carousel.type === CAROUSEL_TYPES.CAROUSEL ? 'checkbox' : undefined },
          { name: 'visibility', label: 'Visibility', field: carouselItem => carouselItemIcon(carouselItem, currentSite.siteDate), component: 'icons' },
          { name: 'actions', label: 'Actions' },
        ]"
        :rows="section.config.carousel.items"
        :rows-per-page-options="[0]"
        hide-pagination
        row-key="key"
      >
        <template #top>
          <div class="q-table__title">
            Carousel {{ $_.startCase(section.config.carousel.type) }}s
          </div>

          <q-space />

          <q-btn
            class="q-mx-sm"
            label="Set Order"
            :disable="section.isTranslation"
            @click="$refs.orderDialog.show()"
          >
            <english-required-tooltip v-if="section.isTranslation" />
          </q-btn>

          <q-btn
            :label="'Add ' + $_.startCase(section.config.carousel.type)"
            outline
            :disable="section.isTranslation"
            @click="editCarouselItem(null)"
          >
            <english-required-tooltip v-if="section.isTranslation" />
          </q-btn>
        </template>

        <template #body-cell="props">
          <q-td
            :props="props"
          >
            <template v-if="props.col.component === 'checkbox'">
              <q-checkbox
                disable
                :model-value="props.value"
              />
            </template>
            <template v-else-if="props.col.name === 'minimum' || props.col.name === 'maximum'">
              {{ props.value }}
            </template>
            <template v-else-if="props.col.name === 'description'||props.col.name === 'title'">
              <div :style="'max-width: 200px; white-space: normal;'">
                {{ props.value }}
              </div>
            </template>
            <template v-else-if="props.col.name === 'linkUrl'">
              <div :style="'max-width: 200px; white-space: normal; word-break: break-all'">
                {{ props.value }}
              </div>
            </template>
            <template v-else-if="props.col.component === 'img'">
              <img
                v-if="props.value"
                height="60px"
                :src="props.value"
              >
            </template>
            <template v-else>
              {{ props.value }}
            </template>
          </q-td>
        </template>

        <template
          #body-cell-visibility="props"
        >
          <q-td
            :props="props"
          >
            <q-icon
              v-for="icon in props.value"
              :key="icon.name"
              :name="icon.name"
              :color="icon.color"
              :size="icon.size"
              :class="icon.class"
            >
              <q-tooltip
                v-if="icon.tooltip"
                class="text-body2"
              >
                {{ icon.tooltip }}
              </q-tooltip>
            </q-icon>
          </q-td>
        </template>
        <template
          #body-cell-actions="props"
        >
          <q-td
            :props="props"
          >
            <slot
              name="row-actions"
              v-bind="props"
            >
              <div class="row q-gutter-sm justify-end no-wrap">
                <slot
                  name="prepend-row-actions"
                  v-bind="props"
                />
                <q-btn
                  :hover="false"
                  label="Edit"
                  @click="editCarouselItem(props.row)"
                />
                <q-btn
                  :hover="false"
                  icon="more_vert"
                  round
                  @click.stop
                >
                  <q-menu>
                    <q-list style="min-width: 180px">
                      <q-item
                        v-close-popup
                        clickable
                        @click="editCarouselItem(props.row)"
                      >
                        <q-item-section avatar>
                          <q-icon name="edit" />
                        </q-item-section>
                        <q-item-section>
                          Edit
                        </q-item-section>
                      </q-item>
                      <q-separator />
                      <q-item
                        v-close-popup
                        clickable
                        @click="deleteCarouselItem(props.row)"
                      >
                        <q-item-section avatar>
                          <q-icon name="delete" />
                        </q-item-section>
                        <q-item-section>
                          {{ $t('actions.remove') }}
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </q-menu>
                </q-btn>
              </div>
            </slot>
          </q-td>
        </template>
      </q-table>
      <set-display-order-dialog
        ref="orderDialog"
        :list="section.config.carousel.items"
        display-field="title"
        @reorder="handleReorder"
      />
    </div>
    <preview
      :key="changeCount"
      :section="section"
      class="q-mb-xl"
    />
    <generic-carousel-form
      ref="genericCarouselForm"
      :section="section"
      :carousel-type="section.config.carousel.type"
      @save="carouselItem => saveCarouselItem(carouselItem)"
    />
  </div>
</template>

<script>
import { CAROUSEL_TYPES, createCarousel, IMAGE_POSITION_OPTIONS, IMAGE_TRANSFORM_OPTIONS, TEXT_ALIGN_OPTIONS, TEXT_POSITION_TYPES } from 'src/models/carousel/Carousel'
import { carouselItemIcon, carouselItemImageUrl, isCarouselItemVisible } from 'src/models/carousel/CarouselItem'
import { LocalizedJsonObject } from 'src/models/model'
import Section from 'src/models/page/Section'
import ButtonStyleEditor from 'src/modules/admin/components/ButtonStyleEditor'
import EnglishRequiredTooltip from 'src/modules/admin/components/EnglishRequiredTooltip'
import SetDisplayOrderDialog from 'src/modules/admin/components/SetDisplayOrderDialog'
import GenericCarouselForm from 'src/modules/admin/section/GenericCarouselForm'
import Preview from 'src/modules/consumer/components/Preview'
export default {
  name: 'GenericCarouselEditor',
  configuration: ['currentSite'],
  components: {
    EnglishRequiredTooltip,
    GenericCarouselForm,
    SetDisplayOrderDialog,
    Preview,
    ButtonStyleEditor
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  data () {
    return {
      changeCount: 0,
      pagination: {
        page: 1,
        rowsPerPage: 0
      }
    }
  },
  created () {
    _.extend(this, { carouselItemImageUrl, carouselItemIcon, isCarouselItemVisible, CAROUSEL_TYPES, IMAGE_TRANSFORM_OPTIONS, IMAGE_POSITION_OPTIONS, TEXT_POSITION_TYPES, TEXT_ALIGN_OPTIONS })
  },
  mounted () {
    if (!this.section.carousel) {
      const newConfig = {
        ..._.cloneDeep(this.section.config),
        carousel: createCarousel()
      }
      this.section.setData({ config: newConfig })
    }
  },
  methods: {
    editCarouselItem (item = null) {
      const index = item ? _.findIndex(this.section.config.carousel.items, { key: item.key }) : null
      this.$refs.genericCarouselForm.show(index)
    },
    deleteCarouselItem (item) {
      const index = _.findIndex(this.section.config.carousel.items, { key: item.key })
      if (index < 0) return
      this.section.config.carousel.items.splice(index, 1)
    },
    saveCarouselItem (item) {
      const index = _.findIndex(this.section.config.carousel.items, { key: item.key })
      if (index === -1) {
        this.section.config.carousel.items.push(item)
      } else {
        this.section.config.carousel.items[index] = item
      }
    },
    handleReorder ({ reorderedList }) {
      this.section.config.carousel.items = reorderedList
    },
    // Only necessary for the imageUrl JSON keys because they aren't automatically localized
    // outside of previews.
    localizeKey (key) {
      const localizedKey = LocalizedJsonObject.localizeKey(key, this.section.language)[0]
      return localizedKey
    },
    setControlsStyle (buttonType, colorName, customColorHex, buttonRadius) {
      this.section.config.carousel.controlsType = buttonType
      this.section.config.carousel.controlsColor = colorName
      this.section.config.carousel.controlsColorHex = customColorHex
      this.section.config.carousel.controlsBorderRadius = buttonRadius
    },
    setButtonStyle (buttonType, colorName, customColorHex, buttonRadius) {
      this.section.config.carousel.buttonType = buttonType
      this.section.config.carousel.buttonColor = colorName
      this.section.config.carousel.buttonColorHex = customColorHex
      this.section.config.carousel.buttonBorderRadius = buttonRadius
    }

  }
}
</script>

<style lang="scss" scoped>
  .schedule {
    position: absolute;
    right: 10px;
    margin-top: 10px;
    background: var(--q-background);
    border-radius: 8px;
  }
</style>
